import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LayersIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M14.5168 8.26781L15.8835 9.00709L16.2172 9.19459C16.9281 9.594 16.9281 10.6238 16.2172 11.0232L11.6897 13.5668C10.6397 14.1568 9.36104 14.1568 8.31103 13.5668L3.78356 11.0232C3.07263 10.6238 3.07263 9.594 3.78356 9.19459L4.11725 9.00709L5.44739 8.24536"
        stroke={props.stroke || "#52565C"}
        strokeWidth="1.25"
      />
      <path
        d="M14.5748 11.9451L16.0845 12.7127C16.8317 13.0889 16.8557 14.1537 16.1261 14.5636L11.6891 17.0564C10.6391 17.6463 9.36046 17.6463 8.31042 17.0564L3.93812 14.5999C3.19607 14.183 3.23696 13.0947 4.00817 12.7354L5.52896 12.0036"
        stroke={props.stroke || "#52565C"}
        strokeWidth="1.25"
      />
      <path
        d="M8.31103 2.94245L3.78356 5.48612C3.07263 5.88553 3.07263 6.91528 3.78356 7.31471L8.31103 9.85842C9.36104 10.4483 10.6397 10.4483 11.6897 9.85842L16.2172 7.31471C16.9281 6.91528 16.9281 5.88554 16.2172 5.48612L11.6897 2.94245C10.6397 2.35252 9.36104 2.35252 8.31103 2.94245Z"
        stroke={props.stroke || "#52565C"}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default LayersIcon;
